//#region Imports
import { createSelector } from '@ngrx/store';
import { toObjectArray } from '@shared/functions/functions';
import * as fromFeature from './../reducers';
//#endregion

const dashboardState = createSelector(
    fromFeature.getCoreState,
    (state: fromFeature.CoreState) => state.dashboard
);

const getDashdata = createSelector(dashboardState, (state) => toObjectArray(state.dashData));

const getDashboardIsLoaded = createSelector(dashboardState, (state) => state.isLoaded);

const getDashboardIsLoading = createSelector(dashboardState, (state) => state.isLoading);

const getDashboardError = createSelector(dashboardState, (state) => state.error);

export const DashboardSelectors = {
    dashboardState,
    getDashdata,
    getDashboardIsLoaded,
    getDashboardIsLoading,
    getDashboardError
};
